<template>
  <el-dialog v-model="dialogVisible" title="填写受邀码" width="30%" @close="close">
    <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules">
      <el-form-item prop="code">
        <el-input v-model="ruleForm.code" @input="trimLR" placeholder="请输入受邀码"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer orangeButton">
        <el-button type="primary" @click="onCheck" :loading="loading">完成</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ElMessageBox, ElMessage } from "element-plus";
import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import { getQRInfo } from "@/http/api/learning";
const dialogVisible = ref(false);
const loading = ref(false);
const ruleFormRef = ref(null);
const ruleForm = ref({
  code: ""
});
const rules = reactive({
  code: [
    {
      required: true,
      message: "请输入受邀码",
      trigger: [""]
    }
  ]
});
const router = useRouter();

function onCheck() {
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      getQRInfoData();
    }
  });
}
const trimLR = () => {
  ruleForm.value.code = ruleForm.value.code.replace(/\s+/g, "");
};
async function getQRInfoData() {
  try {
    loading.value = true;
    let result = await getQRInfo({ qrcode: ruleForm.value.code });
    let { data, message } = result;
    let { flag, groupid, groupinfo } = data;
    loading.value = false;
    dialogVisible.value = false;
    if (flag) {
      if (groupid) {
        showMsg(groupid, groupinfo);
      } else {
        ElMessage.warning(message);
      }
    } else {
      router.push({
        path: "/confirm",
        query: {
          code: ruleForm.value.code
        }
      });
    }
  } catch (error) {
    loading.value = false;
  }
}
function showMsg(groupid, groupinfo) {
  ElMessageBox.alert(`您已获得该课程【${groupinfo.title}】，您可以直接进行学习。`, "受邀课程验证", {
    confirmButtonText: "去学习",
    cancelButtonText: "取消",
    showCancelButton: true,
    callback: (action) => {
      if (action === "confirm") {
        router.push({
          path: "/learning/inviteStudyDetail",
          query: { groupid }
        });
      }
    }
  });
}
function close() {
  ruleForm.value.code = "";
}
defineExpose({
  dialogVisible
});
</script>

<style lang="scss" scoped>
::v-deep(.el-input-group__append) {
  background: $bg-color-orange;
  border: 1px solid $bg-color-orange;
  color: $text-color-white;
}
</style>
